import set from 'lodash/set';
import { pruneUnwantedProperties, requiredArg } from '../utils';
import { getErrorsForPage, getFriendlyErrorMessages } from './messages';

export const createFormValidator =
  ({
    validate = requiredArg('validate'),
    pageName = requiredArg('pageName'),
    translations = requiredArg('translations'),
    getMetadataForFieldName = requiredArg('getMetadataForFieldName'),
    getFormStructure = requiredArg('getFormStructure'),
    getSectionsForPageName = requiredArg('getSectionsForPageName'),
    getSortOrderForFieldNames = requiredArg('getSortOrderForFieldNames'),
  }) =>
  values => {
    try {
      const actualValues = pruneUnwantedProperties(values, getFormStructure());
      const isValid = validate(actualValues);

      if (!isValid) {
        let errors = getErrorsForPage(pageName, validate.errors);

        const errorMessages = getFriendlyErrorMessages({
          errors,
          values: actualValues,
          translations,
          getMetadataForFieldName,
          getFormStructure,
          pageName,
          getSectionsForPageName,
          getSortOrderForFieldNames,
          schema: validate.schema,
        });

        return {
          messages: errorMessages.reduce((messages, errorMessage) => {
            set(messages, errorMessage.fieldName, errorMessage.message);
            return messages;
          }, {}),
          errors: errorMessages.reduce((errors, errorMessage) => {
            set(errors, errorMessage.fieldName, {
              message: errorMessage.message,
              keyword: errorMessage.error.keyword,
            });

            return errors;
          }, {}),
        };
      }
    } catch (err) {
      if (global.__DEBUG__) {
        console.error('Failed to get error messages', err); // eslint-disable-line
      }
    }

    return {};
  };
